import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { NewEmailForm } from "../-components/NewEmailForm";

export const Route = createFileRoute("/_dashboard/emails/organisations/new-email")({
  component: RouteComponent,
  loader: async () => {
    return { crumb: "New organisation email" };
  },
});

function RouteComponent() {
  const search = useRouterState({ select: (s) => s.location.search });

  let orgId = "";
  let returnTo = "";
  if (typeof (search as any) === "string") {
    const params = new URLSearchParams((search as unknown as string) || "");
    orgId = params.get("orgId") || "";
    returnTo = params.get("returnTo") || "";
  } else if (search && typeof search === "object") {
    const s: any = search;
    if (s.orgId) orgId = String(s.orgId);
    if (s.returnTo) returnTo = String(s.returnTo);
  }

  return <NewEmailForm scope="organisation" orgId={orgId} returnTo={returnTo} />;
}
